/* eslint-disable import/no-anonymous-default-export */
import React, { useState } from "react";
import {
  Container,
  Tabs,
  Tab,
  Row,
  Col,
  Spinner,
  Modal,
} from "react-bootstrap";
import useViewBucketList from "./useViewBucketList";
import Header from "../../Common/Header";
import "./ViewBucketList.scss";
import Footer from "../../Common/Footer/Footer";
import { dateFormatter, dateDiff } from "../../../_helpers/dateFormatter";
import { useNavigate } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faAngleLeft, faXmark } from "@fortawesome/free-solid-svg-icons";
import EmptyFeedCard from "../../../_uiComponents/EmptyFeedCard";
import ShortlistedCandidates from "./ShortlistedCandidates";
import { faStar } from "@fortawesome/free-regular-svg-icons";
import { faStar as solidStar } from "@fortawesome/free-solid-svg-icons";
import MainLayout from "../../Common/MainLayout";
export default (props) => {
  const navigate = useNavigate();
  const {
    bucketListData,
    candidatesData,
    loadingBucketList,
    loadingCandidateList,
    shortlistCandidates,
    countTime,
    onViewCandidatesClick,
    countQuestions,
    onViewCandidateProfileClick,
    handleBackClick,
    tabChangesHandler,
    // eslint-disable-next-line no-unused-vars
    onViewcandidateDetail,
    onClickShortlist,
    onClickUnShortlist,
    onPublicProfileClick,
    onDeleteFavouriteClick,
    onViewAssessmentClick,
  } = useViewBucketList();

  return (
    <MainLayout activeMenuItem="bucketlist">
      <Container className="footer-gap">
        <div className="d-flex mb-4 justify-content-between align-items-center">
          <div className="d-flex align-items-center">
            <button
              className="text-primary border-0 mr-2 bg-transparent"
              onClick={handleBackClick}
            >
              <FontAwesomeIcon icon={faAngleLeft} />
            </button>
            <h2 className="text-capitalize">{bucketListData?.title}</h2>
          </div>
        </div>
        <div className="mb-4 hiring-process-dashboard kanban-board-main">
          <Tabs
            defaultActiveKey="AssignedAssessmentKits"
            onSelect={() => tabChangesHandler()}
          >
            <Tab
              eventKey="AssignedAssessmentKits"
              title="Assigned Assessment Kits"
            >
              <div>
                {loadingBucketList ? (
                  <div className="d-flex justify-content-center align-items-center w-100">
                    <Spinner animation="border" variant="primary" />
                  </div>
                ) : (
                  <>
                    {Array.isArray(
                      bucketListData?.assigned_assessments_details
                    ) &&
                    bucketListData?.assigned_assessments_details &&
                    bucketListData.assigned_assessments_details.length ? (
                      <div className="row">
                        {Array.isArray(
                          bucketListData?.assigned_assessments_details
                        ) &&
                          bucketListData?.assigned_assessments_details?.map(
                            (item) => (
                              <div className="col-lg-6 col-md-6 mb-4">
                                <div className="p-4 bg-white border position-relative h-100 rounded-lg shadow-2">
                                  <div className="upper border-bottom">
                                    <div className="d-flex mb-3 ">
                                      <div className="job-info">
                                        <h3 className="font-weight-medium mb-1 text-capitalize text-primary">
                                          {item?.title}
                                        </h3>
                                      </div>
                                    </div>

                                    <div className="d-flex align-items-center fs-smallest mb-3 justify-content-between">
                                      <div>
                                        <p className="mb-0 text-capitalize font-weight-medium mr-2">
                                          Total Topics:{" "}
                                          <span className="text-grey-4 font-weight-400">
                                            {item &&
                                              item.topics &&
                                              item.topics.length}
                                          </span>
                                        </p>
                                        <p className="font-weight-medium mb-2">
                                          Estimated Time:
                                          <span className="text-grey-4 ml-2 font-weight-normal">
                                            {countTime(item?.topics)} Mins
                                          </span>
                                        </p>
                                      </div>
                                      <div>
                                        <p className="mb-0 text-capitalize font-weight-medium mr-2">
                                          Questions:{" "}
                                          <span className="text-grey-4 font-weight-400">
                                            {countQuestions(item?.topics)}
                                          </span>
                                        </p>
                                        <p className="mb-0 text-capitalize font-weight-medium mr-2">
                                          Submit By:{" "}
                                          <span className="text-grey-4 font-weight-400">
                                            {dateFormatter(item?.due_date)}
                                          </span>
                                        </p>
                                      </div>
                                    </div>
                                  </div>
                                  <div className="d-flex justify-content-between align-items-center mt-3 flex-md-wrap flex-lg-nowrap">
                                    <p className="mb-0 mr-2 font-weight-medium text-muted fs-smallest">
                                      {dateDiff(item?.created, new Date())} ago
                                    </p>
                                  </div>
                                </div>
                              </div>
                            )
                          )}
                      </div>
                    ) : (
                      <EmptyFeedCard message="No assessment Kit Found" />
                    )}
                  </>
                )}
              </div>
            </Tab>
            <Tab eventKey="Candidates" title="Mentor Shortlisted Candidates">
              <div className="container">
                <div>
                  {loadingCandidateList ? (
                    <div className="d-flex justify-content-center align-items-center w-100">
                      <Spinner animation="border" variant="primary" />
                    </div>
                  ) : (
                    <>
                      {Array.isArray(candidatesData) &&
                      candidatesData.length > 0 ? (
                        <div className="row">
                          {Array.isArray(candidatesData) &&
                            candidatesData.map((item) => (
                              <div className="col-lg-6 col-md-6 mb-4 ">
                                <div className="bg-white border position-relative h-100 rounded-lg shadow-2 p-3">
                                  <div className="d-flex justify-content-between">
                                    <div className="title">
                                      <h3
                                        className="font-weight-medium mb-3 text-capitalize text-primary"
                                        onClick={() =>
                                          onViewCandidateProfileClick(
                                            item?.candidate_details &&
                                              item.candidate_details?.hash_id
                                          )
                                        }
                                      >
                                        {item?.candidate_details &&
                                          item?.candidate_details?.full_name}
                                      </h3>
                                    </div>

                                    {item?.is_favourite_by_hm === true ? (
                                      <FontAwesomeIcon
                                        icon={solidStar}
                                        className="ml-2 cursor-pointer"
                                        onClick={() =>
                                          onClickUnShortlist(item?.favourite_id)
                                        }
                                        title="UnShortlist"
                                      />
                                    ) : (
                                      <FontAwesomeIcon
                                        icon={faStar}
                                        className="ml-2 cursor-pointer"
                                        onClick={() =>
                                          onClickShortlist(item?.id)
                                        }
                                        title="Shortlist"
                                      />
                                    )}
                                  </div>
                                  <div className="d-flex align-items-center fs-smallest justify-content-between pb-3">
                                    <div>
                                      <ul className="d-flex flex-wrap align-items-center">
                                        <li className="mr-2 py-1  rounded  my-1">
                                          Skills:
                                        </li>
                                        {Array.isArray(
                                          item?.candidate_details?.skills
                                        ) &&
                                        item?.candidate_details?.skills
                                          .length ? (
                                          <>
                                            {Array.isArray(
                                              item?.candidate_details &&
                                                item.candidate_details
                                                  ?.skills &&
                                                item.candidate_details.skills
                                            ) &&
                                              item?.candidate_details &&
                                              item.candidate_details?.skills &&
                                              item.candidate_details.skills.map(
                                                (skill) => (
                                                  <li className="mr-2 py-1 px-2 rounded bg-grey my-1">
                                                    {skill}
                                                  </li>
                                                )
                                              )}
                                          </>
                                        ) : (
                                          <span>Not Available</span>
                                        )}
                                      </ul>

                                      <p className="mb-3 text-capitalize font-weight-medium mr-2 d-flex align-items-center">
                                        {item?.all_interviews_assigned &&
                                        Array.isArray(
                                          item?.all_interviews_assigned
                                        ) &&
                                        item.all_interviews_assigned.length ? (
                                          <div className="skills-list">
                                            {Array.isArray(
                                              item?.all_interviews_assigned &&
                                                item.all_interviews_assigned
                                            ) &&
                                              item?.all_interviews_assigned &&
                                              item.all_interviews_assigned.map(
                                                (assessment) => (
                                                  <div className="flex-wrap d-flex">
                                                    {" "}
                                                    <p
                                                      className="skill text-primary cursor-pointer font-weight-semi"
                                                      onClick={() =>
                                                        onViewAssessmentClick(
                                                          assessment?.id,
                                                          item?.candidate
                                                        )
                                                      }
                                                    >
                                                      {assessment?.title}
                                                    </p>
                                                    <div className="text-right">
                                                      <span
                                                        className={`d-inline-block ${
                                                          assessment?.assessment_kit_accepted ===
                                                          true
                                                            ? "label-voilet"
                                                            : "label-yellow"
                                                        } rounded position px-2 ml-2`}
                                                      >
                                                        {assessment?.assessment_kit_accepted
                                                          ? "Accepted"
                                                          : "Pending"}
                                                      </span>
                                                    </div>
                                                  </div>
                                                )
                                              )}
                                          </div>
                                        ) : (
                                          "Not Available"
                                        )}
                                      </p>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            ))}
                        </div>
                      ) : (
                        <EmptyFeedCard message="No candidates Found in BucketList" />
                      )}
                    </>
                  )}
                </div>
              </div>
            </Tab>
            <Tab
              eventKey="ShortlistedCandidates"
              title="ShortListed Candidates"
            >
              <ShortlistedCandidates
                onClickUnShortlist={onClickUnShortlist}
                onPublicProfileClick={onPublicProfileClick}
                shortlistCandidates={shortlistCandidates}
                onClickShortlist={onClickShortlist}
                onDeleteFavouriteClick={onDeleteFavouriteClick}
                onViewAssessmentClick={onViewAssessmentClick}
              />
            </Tab>
          </Tabs>
        </div>
      </Container>

      <Footer />
    </MainLayout>
  );
};
